import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import { saveEquipment } from "./supabaseDB";
import AuthScreen from "./AuthScreen";
import LegalScreen from "./LegalScreen";
import OnboardingScreen from "./OnboardingScreen";
import ChoreHabitApp from "./ChoreHabitApp";
import CrewTutorialScreen from "./CrewTutorialScreen";

// ─── SET PASSWORD SCREEN (for invited crew members) ──────────────────────────
function SetPasswordScreen(props) {
  var onComplete = props.onComplete || function(){};
  var sp1=useState(""); var pw=sp1[0]; var setPw=sp1[1];
  var sp2=useState(""); var confirm=sp2[0]; var setConfirm=sp2[1];
  var sp3=useState(null); var err=sp3[0]; var setErr=sp3[1];
  var sp4=useState(false); var saving=sp4[0]; var setSaving=sp4[1];
  var sp5=useState(false); var done=sp5[0]; var setDone=sp5[1];

  var FM = { fontFamily:"'DM Mono','Courier New',monospace" };
  var inp = { background:"#13151F", border:"1px solid #2E3248", borderRadius:8, padding:"12px 14px", color:"#E8EAF0", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", outline:"none", width:"100%", boxSizing:"border-box" };

  function save() {
    if (pw.length < 8) { setErr("Password must be at least 8 characters"); return; }
    if (pw !== confirm) { setErr("Passwords do not match"); return; }
    setSaving(true); setErr(null);
    supabase.auth.updateUser({ password: pw }).then(function(res) {
      setSaving(false);
      if (res.error) { setErr(res.error.message); return; }
      setDone(true);
      setTimeout(onComplete, 1500);
    });
  }

  return (
    <div style={{ ...FM, background:"#0F1117", minHeight:"100vh", color:"#E8EAF0", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ width:"100%", maxWidth:400 }}>
        <img src="/chorehabit-app-tile.svg" alt="ChoreHabit" style={{ width:64, height:64, borderRadius:16, marginBottom:24 }} />
        {done ? (
          <div style={{ textAlign:"center" }}>
            <div style={{ fontSize:32, marginBottom:12 }}>✅</div>
            <div style={{ fontSize:16, fontWeight:700, color:"#4CAF6E", marginBottom:8 }}>Password set!</div>
            <div style={{ fontSize:12, color:"#9AA0C0" }}>Taking you to your dashboard...</div>
          </div>
        ) : (
          <div>
            <div style={{ fontSize:11, color:"#F5A623", fontWeight:700, letterSpacing:"0.2em", textTransform:"uppercase", marginBottom:8 }}>Welcome to ChoreHabit</div>
            <div style={{ fontSize:24, fontWeight:700, marginBottom:6 }}>Set your password</div>
            <div style={{ fontSize:13, color:"#9AA0C0", marginBottom:28, lineHeight:1.6 }}>Choose a password to secure your crew account.</div>
            <div style={{ marginBottom:14 }}>
              <div style={{ fontSize:10, color:"#6B7094", letterSpacing:"0.12em", textTransform:"uppercase", fontWeight:600, marginBottom:6 }}>New Password</div>
              <input style={inp} type="password" placeholder="8+ characters" value={pw} onChange={function(e){ setPw(e.target.value); setErr(null); }} />
            </div>
            <div style={{ marginBottom:14 }}>
              <div style={{ fontSize:10, color:"#6B7094", letterSpacing:"0.12em", textTransform:"uppercase", fontWeight:600, marginBottom:6 }}>Confirm Password</div>
              <input style={inp} type="password" placeholder="Repeat password" value={confirm} onChange={function(e){ setConfirm(e.target.value); setErr(null); }} />
            </div>
            {err && <div style={{ fontSize:11, color:"#E05C5C", marginBottom:12 }}>{err}</div>}
            <button
              onClick={save}
              disabled={saving||!pw||!confirm}
              style={{ width:"100%", background:saving||!pw||!confirm?"#1E2230":"#F5A623", border:"none", borderRadius:10, color:saving||!pw||!confirm?"#6B7094":"#0F1117", fontSize:13, ...FM, fontWeight:700, padding:15, cursor:saving||!pw||!confirm?"not-allowed":"pointer", textTransform:"uppercase", letterSpacing:"0.1em" }}
            >
              {saving?"Setting password...":"Set Password & Continue →"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default function App() {
  var s1=useState("loading"); var screen=s1[0];    var setScreen=s1[1];
  var s2=useState(null);      var user=s2[0];      var setUser=s2[1];
  var s3=useState(null);      var profile=s3[0];   var setProfile=s3[1];
  var s4=useState(null);      var initData=s4[0];  var setInitData=s4[1];
  var s5=useState(null);      var legalPage=s5[0]; var setLegalPage=s5[1];
  var s6=useState(null);      var authError=s6[0]; var setAuthError=s6[1];
  var s7=useState(false);     var showTutorial=s7[0]; var setShowTutorial=s7[1];

  useEffect(function() {
    // Listen for auth state changes — catches invite link clicks automatically
    var listener = supabase.auth.onAuthStateChange(function(event, session) {
      if (event === "SIGNED_OUT" || !session) {
        setUser(null); setProfile(null); setScreen("auth");
      } else if (event === "PASSWORD_RECOVERY") {
        setScreen("setpassword");
      } else if (event === "SIGNED_IN") {
        // Check if this is an invited user who needs to set a password
        var meta = session && session.user && session.user.user_metadata;
        var isInvite = meta && meta.role === "crew" && !meta.tutorial_complete;
        if (isInvite && !session.user.last_sign_in_at) {
          setScreen("setpassword");
        } else if (session && session.user) {
          loadProfile(session.user);
        }
      } else if (event === "USER_UPDATED") {
        if (session && session.user) {
          loadProfile(session.user);
        }
      }
    });

    // Check for URL params
    var urlParams = new URLSearchParams(window.location.search);
    var checkoutStatus = urlParams.get("checkout");
    var skipTrialParam = urlParams.get("skipTrial");
    if (checkoutStatus === "success" || skipTrialParam) {
      window.history.replaceState(null, "", window.location.pathname);
    }
    // If skipTrial param - go to create screen with choosePlan flag
    if (skipTrialParam === "true") {
      setScreen("auth_skiptrial");
    }

    // Check for existing session on load
    supabase.auth.getSession().then(function(res) {
      var session = res.data && res.data.session;
      if (session && session.user) {
        loadProfile(session.user);
      } else {
        // Check if there is an invite token in the URL
        var hash = window.location.hash;
        if (hash && (hash.indexOf("type=invite") >= 0 || hash.indexOf("type=recovery") >= 0)) {
          // Supabase onAuthStateChange will handle this automatically
          // Show a password setup screen
          setScreen("setpassword");
        } else {
          setScreen("auth");
        }
      }
    });

    return function() {
      if (listener && listener.data && listener.data.subscription) {
        listener.data.subscription.unsubscribe();
      }
    };
  }, []);

  function loadProfile(authUser) {
    supabase.from("profiles").select("*, companies(*)").eq("id", authUser.id).single()
      .then(function(res) {
        if (res.data) {
          var p = res.data;
          var company = p.companies || {};
          var merged = {
            id: authUser.id,
            email: authUser.email,
            name: p.full_name || authUser.email,
            role: p.role || "admin",
            lang: p.lang || "en",
            plan: company.plan || "free",
            billing: company.billing || "monthly",
            company: company.name || "My Operation",
            company_id: p.company_id,
            isFoundingMember: company.is_founding_member || false,
            tutorialComplete: p.tutorial_complete || false,
          };
          setUser(merged);
          setProfile(merged);
          // Always reset tutorial state first
          setShowTutorial(false);
          setScreen("app");
          // Clear URL hash if present
          if (window.location.hash) window.history.replaceState(null,"",window.location.pathname);
          // Only show tutorial for crew members who haven't completed it
          if (merged.role === "crew" && !merged.tutorialComplete) {
            setShowTutorial(true);
          }
        } else {
          // Check if this is an invited crew member (has role in metadata)
          var meta = authUser.user_metadata || {};
          if (meta.role === "crew") {
            setUser({ id: authUser.id, email: authUser.email, name: meta.full_name||authUser.email, role: "crew", lang: "en", plan: "free", company_id: meta.company_id, tutorialComplete: false });
            setShowTutorial(true);
            setScreen("app");
          } else {
            setUser({ id: authUser.id, email: authUser.email, name: authUser.email, role: "admin", lang: "en", plan: "free" });
            setScreen("onboarding");
          }
        }
      })
      .catch(function() { setScreen("auth"); });
  }

  function completeTutorial() {
    setShowTutorial(false);
    // Mark tutorial complete in Supabase so it never shows again
    if (user && user.id) {
      supabase.from("profiles").update({ tutorial_complete: true }).eq("id", user.id)
        .then(function() {
          // Update local user state too
          setUser(function(u){ return u ? Object.assign({},u,{tutorialComplete:true}) : u; });
        });
    }
  }

  function handleAuth(result) {
    setAuthError(null);
    if (result.type === "new") {
      var skipTrial = result.skipTrial || false;
      var selectedPlan = result.plan || "free";
      var STRIPE_PRICES_MAP = { starter:"price_1TVMs21gK47wucI8ApDvHpcq", captain:"price_1TVMuB1gK47wucI8A5t8WoGU", pro:"price_1TVMwc1gK47wucI8cUJZTf4x" };
      supabase.auth.signUp({
        email: result.email,
        password: result.password,
        options: {
          data: {
            full_name: result.user.name,
            company: result.user.company,
            plan: result.user.plan,
            role: "admin",
            lang: result.user.lang || "en",
          }
        }
      }).then(function(res) {
        if (res.error) { setAuthError(res.error.message); return; }
        var authUser = res.data && res.data.user;
        if (!authUser) { setAuthError("Signup failed. Please try again."); return; }
        var needsConfirm = authUser.identities && authUser.identities.length === 0;
        if (needsConfirm) { setAuthError("CHECK_EMAIL"); return; }
        var newUser = Object.assign({}, result.user, { id: authUser.id });
        setUser(newUser);
        if (skipTrial && STRIPE_PRICES_MAP[selectedPlan]) {
          fetch("/.netlify/functions/create-checkout", {
            method:"POST", headers:{"Content-Type":"application/json"},
            body:JSON.stringify({ priceId:STRIPE_PRICES_MAP[selectedPlan], email:result.email, userId:authUser.id, companyId:"", isFounder:true })
          })
          .then(function(r){ return r.json(); })
          .then(function(data){ if (data.url) window.location.href = data.url; else setScreen("onboarding"); })
          .catch(function(){ setScreen("onboarding"); });
        } else {
          setScreen("onboarding");
        }
      });
    } else {
      // rememberMe=true uses persistent session, false uses session-only
      var sessionOpts = result.rememberMe === false ? {} : {};
      supabase.auth.signInWithPassword({
        email: result.email,
        password: result.password,
      }).then(function(res) {
        if (res.error) { setAuthError(res.error.message); return; }
        var authUser = res.data && res.data.user;
        if (authUser) loadProfile(authUser);
      });
    }
  }

  function handleOnboardingComplete(data) {
    setInitData(data);
    supabase.auth.getUser().then(function(res) {
      if (!res.data || !res.data.user) { setScreen("app"); return; }
      var authUser = res.data.user;
      supabase.from("profiles").select("company_id, full_name").eq("id", authUser.id).single()
        .then(function(profileRes) {
          var companyId = profileRes.data && profileRes.data.company_id;
          var adminName = profileRes.data && profileRes.data.full_name;
          // Push onboarding equipment to Supabase
          if (companyId && data && data.equipment && data.equipment.length > 0) {
            data.equipment.forEach(function(eq) { saveEquipment(companyId, eq); });
          }
          // Send crew invites if any were added during onboarding
          if (companyId && data && data.crew && data.crew.length > 0) {
            data.crew.forEach(function(member) {
              if (member.email) {
                fetch("/.netlify/functions/invite-crew", {
                  method:"POST",
                  headers:{"Content-Type":"application/json"},
                  body:JSON.stringify({
                    email: member.email,
                    fullName: member.name || member.email,
                    companyId: companyId,
                    invitedBy: adminName || authUser.email,
                  })
                });
              }
            });
          }
          loadProfile(authUser);
        })
        .catch(function() { loadProfile(authUser); });
    });
  }

  function handleSignOut() {
    supabase.auth.signOut().then(function() {
      setUser(null); setProfile(null); setInitData(null); setShowTutorial(false); setScreen("auth");
    });
  }

  if (legalPage) {
    return <LegalScreen page={legalPage} onBack={function(){ setLegalPage(null); }} />;
  }

  if (screen === "loading") {
    return (
      <div style={{ background:"#0F1117", minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:16 }}>
        <img src="/chorehabit-app-tile.svg" alt="ChoreHabit" style={{ width:64, height:64, borderRadius:16 }} />
        <div style={{ fontFamily:"'DM Mono',monospace", fontSize:11, color:"#6B7094", letterSpacing:"0.15em", textTransform:"uppercase" }}>Loading...</div>
      </div>
    );
  }

  if (screen === "setpassword") {
    return <SetPasswordScreen onComplete={function(){ setScreen("loading"); supabase.auth.getSession().then(function(r){ if(r.data&&r.data.session) loadProfile(r.data.session.user); else setScreen("auth"); }); }} />;
  }

  if (screen === "auth") {
    return (
      <AuthScreen
        onAuth={handleAuth}
        onLegal={function(page){ setLegalPage(page); }}
        authError={authError}
      />
    );
  }

  if (screen === "onboarding") {
    return (
      <OnboardingScreen
        user={user}
        onComplete={handleOnboardingComplete}
      />
    );
  }

  // Show tutorial overlay for crew members on first login
  if (screen === "app" && showTutorial===true) {
    return (
      <CrewTutorialScreen
        onComplete={completeTutorial}
        onClose={null}
        requirePassword={user && user.role==="crew" && !user.tutorialComplete}
      />
    );
  }

  if (screen === "app") {
    return (
      <ChoreHabitApp
        currentUser={user || profile}
        onShowTutorial={function(){ setShowTutorial(true); }}
        isAdmin={user ? user.role === "admin" : true}
        initialEquipment={initData ? initData.equipment : null}
        initialCrew={initData ? initData.crew : null}
        companyName={user ? user.company : null}
        onLogout={handleSignOut}
      />
    );
  }

  return null;
}
